


















import Vue from "vue";
import { Cell } from "../../services/vo";
import { DomCell, CellPosition, VueConstructor, InputEl } from "vue/types/vue";
import { handleKeyPress } from "@/services/inputservice";
export default (Vue as VueConstructor<
  Vue & {
    $refs: {
      inputElement: HTMLInputElement;
      chr: HTMLDivElement;
    };
    inputMode: string,
  }
>).extend({
  props: {
    cell: Object as () => Cell,
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fontSize: "36px",
      letter: "",
      inputType: "",
      arrow: "",
      dash: "",
      number: "",
      marked: false,
      selected: false,
      state: this.cell.state,
      update: 0,
      notes: {
        v: "",
        h: ""
      }
    };
  },
  inject: {
    inputMode: {
      from: "INPUT_MODE",
      default: 'none'
    }
  },
  created() {
  },
  mounted() {
    const domCell: DomCell = { x: this.getX, y: this.getY, dom: this };
    this.$emit("addDOMCell", domCell);
    this.setFontSize();

    const pattern = /[a-z]/i;
    if (pattern.test(this.state)) {
      this.letter = this.state;
    }

  },
  computed: {
    boxClass: function (): any {
      const isSel = this.selected;
      const mark = this.isMarked;

      return {
        selected: isSel,
        dark: this.isDark,
        marked: mark,


        [`x=${this.cell.getPos().x}`]: true,
        [`y=${this.cell.getPos().y}`]: true
      };
    },
    cellStyle: function (): any {

      return {
        "font-size": this.fontSize,
      }
    },
    getX: function (): number {
      return this.cell.getPos().x;
    },
    getY: function (): number {
      return this.cell.getPos().y;
    },
    hasCorner: function (): boolean {
      return this.number !== "";
    },
    hasArrow: function (): boolean {
      return this.arrow !== "";
    },
    hasDash: function (): boolean {
      return this.dash !== "";
    },
    arrowClass: function (): any {
      let arrowDirection = "";
      switch (this.arrow) {
        case "r":
          arrowDirection = "down-right";
          break;
        case "d":
          arrowDirection = "right-down";
          break;
      }
      return {
        arrow: true,
        [arrowDirection]: true
      };
    },
    dashClass: function (): any {
      return {
        dash: this.hasDash,
        [this.dash]: true
      };
    },
    splitClass: function (): any {
      let splitDirection = "";
      switch (this.state) {
        case "2":
          splitDirection = "right";
          break;
        case "3":
          splitDirection = "down";
          break;
      }
      return {
        split: this.isSplit,
        [splitDirection]: true
      };
    },

    isMarked: function (): boolean {
      return this.marked;
    },
    isDark: function (): boolean {
      return this.state === "0";
    },
    isSplit: function (): boolean {
      return this.state === "2" || this.state === "3";
    },
    isSelectable: function (): boolean {
      return !this.isDark && !this.isSplit;
    },
    getState: function (): string {
      return this.state;
    }
  },
  methods: {
    select: async function () {
      this.selected = true;
    },
    deselect: function () {
      this.selected = false;
    },
    mark: function () {
      this.marked = true;
    },
    unmark: function () {
      this.marked = false;
    },
    type: function () {
      let input: string = this.$refs.inputElement.value.toUpperCase();
      this.$refs.inputElement.value = "";
      if (input.length > 0) {
        let letterArray = input.split("");

        this.$emit("letterInput", letterArray);
      } else if (input.length === 1) {
        //this.letter = input;
        this.$emit("letterInput", input);
      }
    },
    setState(state: string) {
      this.state = state;
    },
    setStart: function (number: string): void {
      this.number = number;
    },
    setArrow: function (dir: string): void {
      this.arrow = dir;
    },
    setDash: function (dir: string): void {
      this.dash = dir;
    },
    setFontSize: function (): void {
      const font = this.$refs.chr ? this.$refs.chr.clientWidth * 0.8 + "px" : "36px";
      this.fontSize = font; //this.$refs.chr ? this.$refs.chr.clientWidth * 0.8 + "px" : "36px";
    },
    focus: function (): void {
      try {

        this.$refs.inputElement?.focus();
      }
      catch (erro) {
        console.log("err");
      }
    },
    blur: function (): void {
      try {

        this.$refs.inputElement?.blur();
      } catch (error: any) {
        console.log("err");
      }
    },
    clicked: function () {
      if (this.readOnly) {
        return;
      }
      if (this.isSelectable) {
        //this.$emit("selectedCell", { x: this.cell.getPos().x, y: this.cell.getPos().y, dir: true });
        this.$emit("selectedCell", { cell: this.cell, dir: true });
      }
      this.$emit("clicked", this.cell);
    },
    updateCell: function (): void {
      //this.state = this.cell.state;
      this.update += 1; // Math.floor(Math.random() * 1000);
    },
    handleInputModeText: function (evt: KeyboardEvent) {
      if (this.inputMode != "text") return;

      let input: string = this.$refs.inputElement.value.toLowerCase();
      this.$refs.inputElement.value = "";

      let eventPayload: KeyboardEvent = {} as KeyboardEvent

      if (["Backspace", " "].includes(evt.key)) {
        eventPayload = evt;
        handleKeyPress(eventPayload)
      } else {
        for (let k of input) {

          eventPayload = { key: k } as KeyboardEvent
          handleKeyPress(eventPayload)

        }
      }
    }
  },
  watch: {
    "cell.update": function () {
      console.log("updateCell");
    },
    letter: function () {
      //   console.log(neVal);
      // console.log(this.letter);
    },
    mark: function () { },
    "getFontSize": function () {
      console.log("update chr");
    }
  }
});
